import { jsx as t } from "react/jsx-runtime";
const e = ({ size: o = 24, color: r = "#000000", ...n }) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    viewBox: `0 0 ${o} ${o}`,
    fill: "none",
    ...n,
    children: /* @__PURE__ */ t(
      "path",
      {
        d: "M20.5333 21.5999C20.5333 20.1113 20.5333 19.367 20.3496 18.7613C19.936 17.3977 18.8689 16.3306 17.5052 15.917C16.8996 15.7332 16.1553 15.7332 14.6667 15.7332H9.33335C7.84474 15.7332 7.10044 15.7332 6.49479 15.917C5.13116 16.3306 4.06405 17.3977 3.6504 18.7613C3.46667 19.367 3.46667 20.1113 3.46667 21.5999M16.8 7.1999C16.8 9.85087 14.651 11.9999 12 11.9999C9.34904 11.9999 7.20001 9.85087 7.20001 7.1999C7.20001 4.54894 9.34904 2.3999 12 2.3999C14.651 2.3999 16.8 4.54894 16.8 7.1999Z",
        stroke: r,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
export {
  e as UserIcon
};
